import { Link } from 'react-router-dom';
import { SELLER, SellerContacts } from './sellerInfo';

export default function Oferta() {
  const s = SELLER;

  return (
    <div className="container page" style={{ textAlign: 'left' }}>
      <h1>Публичная оферта</h1>

      <p>
        Настоящий документ является официальным предложением (публичной офертой) {s.fullName}, ИНН{' '}
        {s.inn}, ОГРНИП {s.ogrnip} (далее — «Продавец»), заключить договор розничной купли‑продажи
        товаров дистанционным способом с любым дееспособным лицом (далее — «Покупатель») на условиях,
        изложенных ниже.
      </p>

      <SellerContacts />

      <section>
        <h2>1. Термины и общие положения</h2>
        <ol>
          <li>
            Оферта составлена в соответствии с Гражданским кодексом РФ (ст. 435–438), Законом РФ «О
            защите прав потребителей», Правилами продажи товаров по договору розничной купли‑продажи
            (в том числе дистанционным способом), утверждёнными постановлением Правительства РФ.
          </li>
          <li>
            Размещение товаров и информации о них на сайте является приглашением делать оферты. Заказ,
            оформленный Покупателем на сайте, рассматривается как оферта Покупателя купить выбранный
            товар на условиях настоящего документа.
          </li>
          <li>
            Акцепт настоящей оферты осуществляется путем оформления заказа на сайте и/или оплаты заказа
            (полной или частичной) с подтверждением согласия с условиями оферты. С момента акцепта
            договор считается заключенным.
          </li>
          <li>
            Продавец вправе изменять условия оферты. Новая редакция вступает в силу с момента
            публикации на сайте и применяется к заказам, оформленным после публикации.
          </li>
        </ol>
      </section>

      <section>
        <h2>2. Предмет договора</h2>
        <ol>
          <li>
            Продавец обязуется передать Покупателю товары (сантехническая продукция и сопутствующие
            товары), представленные на сайте, а Покупатель обязуется оплатить и принять товар.
          </li>
          <li>
            Существенные условия (наименование, характеристики, цена, наличие, способы оплаты и
            доставки) определяются на основании информации на сайте и данных оформленного заказа.
          </li>
          <li>
            Изображения товаров на сайте носят справочный характер и могут незначительно отличаться от
            фактического вида товара без потери потребительских свойств.
          </li>
        </ol>
      </section>

      <section>
        <h2>3. Оформление заказа</h2>
        <ol>
          <li>
            Для оформления заказа Покупатель указывает необходимые данные (ФИО, телефон, адрес
            доставки при выборе доставки, e‑mail при необходимости) и подтверждает согласие с офертой
            и <Link to="/privacy">политикой конфиденциальности</Link>.
          </li>
          <li>
            Покупатель гарантирует достоверность предоставленных данных. Риски, связанные с
            некорректными данными (ошибка в адресе, телефоне и т.д.), несет Покупатель.
          </li>
          <li>
            Продавец вправе уточнять детали заказа и доставки. В случае невозможности связаться с
            Покупателем для подтверждения существенных условий Продавец вправе отменить заказ и
            вернуть оплаченные денежные средства (если оплата была произведена).
          </li>
          <li>
            Неоплаченный заказ может быть аннулирован по истечении срока резерва, указанного при
            оформлении / в личном кабинете.
          </li>
        </ol>
      </section>

      <section>
        <h2>4. Цена товара и оплата</h2>
        <ol>
          <li>Цены на сайте указаны в рублях РФ и могут быть изменены Продавцом до момента акцепта.</li>
          <li>
            Для розничных заказов на сайте доступна онлайн‑оплата банковской картой / через платёжный
            сервис Т‑Банка. Данные карты на сайте Продавца не обрабатываются и не хранятся.
          </li>
          <li>
            Безналичная оплата по счёту (перевод по реквизитам) может применяться для оптовых /
            корпоративных заказов по согласованию с Продавцом; реквизиты предоставляются в счёте или
            по запросу.
          </li>
          <li>
            При оплате Продавец формирует и направляет кассовый чек в соответствии с требованиями
            законодательства РФ о применении ККТ (как правило — на телефон и/или e‑mail Покупателя).
          </li>
          <li>
            Возврат денежных средств при отказе от товара / расторжении договора производится тем же
            способом, которым была произведена оплата (если стороны не согласовали иное), в сроки,
            установленные законом. Возврат по эквайрингу Т‑Банка может обрабатываться вручную
            Продавцом после приёмки возврата.
          </li>
        </ol>
      </section>

      <section>
        <h2>5. Доставка и передача товара</h2>
        <ol>
          <li>
            Условия, стоимость и ориентировочные сроки доставки указываются при оформлении заказа и
            зависят от региона, способа доставки и габаритов. Подробнее — на странице{' '}
            <Link to="/delivery">«Доставка и возврат»</Link>.
          </li>
          <li>
            Покупатель обязан обеспечить возможность приема товара по указанному адресу в согласованное
            время.
          </li>
          <li>
            При получении товара Покупатель (или его представитель) проверяет целостность упаковки,
            комплектность, отсутствие видимых повреждений и соответствие заказу. Подпись в
            товаросопроводительных документах / акт получения подтверждает, что товар принят без
            видимых недостатков (если замечания не зафиксированы).
          </li>
          <li>
            Риск случайной гибели или повреждения товара переходит к Покупателю с момента передачи
            товара.
          </li>
          <li>
            Вместе с товаром / при передаче Покупателю предоставляется информация о порядке и сроках
            возврата (памятка). Актуальная памятка также доступна на сайте:{' '}
            <Link to="/return-memo">/return-memo</Link>.
          </li>
        </ol>
      </section>

      <section>
        <h2>6. Возврат и обмен</h2>
        <ol>
          <li>
            Покупатель вправе отказаться от товара в любое время до его передачи. После передачи —
            вправе отказаться от товара надлежащего качества в течение 7 дней. Если письменная
            информация о порядке и сроках возврата не была предоставлена при доставке — срок отказа
            может составлять до 3 месяцев (ст. 26.1 Закона РФ «О защите прав потребителей»).
          </li>
          <li>
            Возврат товара надлежащего качества возможен при сохранении товарного вида,
            потребительских свойств, а также документов, подтверждающих покупку (при их отсутствии
            допускаются иные доказательства приобретения у Продавца).
          </li>
          <li>
            Товары с индивидуально‑определенными свойствами, изготовленные / подобранные под заказ
            Покупателя, возврату надлежащего качества не подлежат.
          </li>
          <li>
            Возврат / замена товара ненадлежащего качества осуществляется по правилам Закона РФ «О
            защите прав потребителей». Продавец вправе провести проверку качества / экспертизу.
          </li>
          <li>
            Расходы по обратной доставке товара надлежащего качества, как правило, несет Покупатель,
            если иное не предусмотрено законом. Денежные средства возвращаются в сроки, установленные
            законом, за вычетом расходов Продавца на доставку от Покупателя возвращенного товара (в
            случаях, предусмотренных законом).
          </li>
          <li>
            Порядок оформления возврата описан на страницах{' '}
            <Link to="/delivery">«Доставка и возврат»</Link> и{' '}
            <Link to="/return-memo">«Памятка о возврате»</Link>.
          </li>
        </ol>
      </section>

      <section>
        <h2>7. Гарантия и сервис</h2>
        <ol>
          <li>
            Гарантийные обязательства устанавливаются производителем и/или Продавцом и указываются в
            карточке товара и/или в документации к товару.
          </li>
          <li>
            Продавец не несет ответственности за недостатки, возникшие вследствие неправильного
            монтажа / эксплуатации, нарушения инструкций, а также действий третьих лиц.
          </li>
        </ol>
      </section>

      <section>
        <h2>8. Персональные данные</h2>
        <p>
          Обработка персональных данных осуществляется Продавцом в соответствии с{' '}
          <Link to="/privacy">Политикой конфиденциальности</Link>, размещенной на сайте. Оформляя
          заказ, Покупатель подтверждает, что ознакомлен и согласен с указанной политикой в части,
          необходимой для исполнения договора. Рекламные и информационные рассылки направляются
          только при отдельном согласии Покупателя. Аналитические cookie (Яндекс.Метрика) — при
          согласии в <Link to="/cookies">баннере cookie</Link>.
        </p>
      </section>

      <section>
        <h2>9. Заключительные положения</h2>
        <ol>
          <li>К отношениям сторон применяется право Российской Федерации.</li>
          <li>
            Претензии направляются на e‑mail: <a href={`mailto:${s.email}`}>{s.email}</a> или по
            телефону <a href={`tel:${s.phoneTel}`}>{s.phoneDisplay}</a>. Срок рассмотрения претензии —
            в пределах сроков, установленных законодательством о защите прав потребителей (в том
            числе ст. 22 Закона РФ «О защите прав потребителей» для отдельных денежных требований).
          </li>
          <li>
            Споры подлежат разрешению в суде в соответствии с законодательством РФ, с учетом прав
            потребителя на выбор подсудности.
          </li>
        </ol>
      </section>

      <p style={{ opacity: 0.8, marginTop: 24 }}>
        © {new Date().getFullYear()} {s.name}. Последнее обновление: {s.updatedAt}
      </p>
    </div>
  );
}
